import { motion } from "framer-motion";
import { Github, Linkedin } from "lucide-react";

const SocialLinks = ({
  position = "left", // "left" or "right"
  email = null,
  delay = 2,
  className = "",
}) => {
  const socialLinks = [
    {
      href: "https://github.com/anthonynjeri",
      icon: Github,
      label: "GitHub",
    },
    {
      href: "https://www.linkedin.com/in/anthonynjeri/",
      icon: Linkedin,
      label: "LinkedIn",
    },
  ];

  const positionClasses =
    position === "left"
      ? "fixed left-6 lg:left-10 bottom-0"
      : "fixed right-6 lg:right-10 bottom-0";

  if (email && position === "right") {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: delay + 0.2 }}
        className={`${positionClasses} hidden lg:flex flex-col items-center space-y-6 z-10 ${className}`}
      >
        <a
          href={`mailto:${email}`}
          className="text-lightSlate hover:text-accent hover:-translate-y-1 transition-all duration-300 [writing-mode:vertical-rl] text-sm font-mono tracking-wider interactive"
        >
          {email}
        </a>
        <div className="w-px h-24 bg-lightSlate"></div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay }}
      className={`${positionClasses} hidden lg:flex flex-col items-center space-y-6 z-10 ${className}`}
    >
      <div className="flex flex-col space-y-5">
        {socialLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lightSlate hover:text-accent hover:-translate-y-1 transition-all duration-300 interactive"
            aria-label={link.label}
          >
            <link.icon size={20} />
          </a>
        ))}
      </div>
      <div className="w-px h-24 bg-lightSlate"></div>
    </motion.div>
  );
};

export default SocialLinks;
